<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 3C4 2.44772 4.44772 2 5 2H15C15.5523 2 16 2.44772 16 3C16 3.55228 15.5523 4 15 4H5C4.44772 4 4 3.55228 4 3Z"
      fill="currentColor"
    />
    <path
      d="M4 17C4 16.4477 4.44772 16 5 16H15C15.5523 16 16 16.4477 16 17C16 17.5523 15.5523 18 15 18H5C4.44772 18 4 17.5523 4 17Z"
      fill="currentColor"
    />
    <path
      d="M4 10C4 9.44772 4.44772 9 5 9H15C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H5C4.44772 11 4 10.5523 4 10Z"
      fill="currentColor"
    />
  </svg>
</template>
